export const seniorWebDesignerResume = `
【職務概要】
Webディレクターとして約3年の経験を持ち、主にコーポレートサイトやECサイト、メディアサイトのディレクション業務に携わってきました。特にクライアントの要望を的確に汲み取り、デザイナーやエンジニアとの連携を円滑に進めることを得意としています。これまでの経験で培った要件定義やワイヤーフレーム作成、プロジェクト進行管理のスキルを活かし、クライアントの課題解決に貢献してきました。

近年はUI/UXの改善やSEO対策、アクセス解析などのデータ分析にも積極的に取り組み、サイトの継続的な改善提案を行っています。また、WordPress等のCMSを活用したサイト構築・運用の知識も深め、クライアントの運用負担軽減にも注力しています。今後はさらにマーケティング視点を強化し、ユーザー体験の向上とビジネス成果の両立を目指したWebディレクションのスキルを磨いていきたいと考えています。

【職務経歴】
○ 株式会社Algomaticデジタル（2022年4月〜現在）
・会社概要：従業員50名のWeb制作会社。企業向けコーポレートサイトやECサイト、メディアサイトの企画・制作・運用を主軸とする
・職務内容：Webディレクター
 - コーポレートサイト、ECサイト、LP制作のディレクション業務
 - クライアントとの打ち合わせ、要件定義、ワイヤーフレーム作成
 - デザイン・コーディング工程の進行管理
 - Google Analyticsを活用したサイト分析とレポート作成
 - WordPress等のCMSを使用したサイト構築と運用サポート
・具体的な成果：
 - アパレルECサイトのリニューアルプロジェクトで、UI/UX改善により直帰率20%減少、CVR15%向上を実現
 - 製造業向けコーポレートサイトで、SEO対策とコンテンツ改善により自然検索流入数を前年比60%増加
 - 中規模案件（500〜800万円）を年間5件、小規模案件を年間10件以上担当
・使用した技術・ツール：
 - ワイヤーフレーム作成：Figma、Adobe XD
 - プロジェクト管理：Backlog、Slack、Google Workspace
 - 解析・計測：Google Analytics、Google Search Console
 - CMS：WordPress、Movable Type
・身につけたスキル：
 - 複数プロジェクトの並行進行管理能力
 - クライアントのビジネス課題を理解したWebサイト設計力
 - SEO/UI/UXの知識とデータに基づく改善提案力

○ 株式会社Algomaticテクノロジーズ（2020年4月〜2022年3月）
・会社概要：従業員120名のITソリューション企業。Web制作部門とシステム開発部門を持つ
・職務内容：Webディレクター補佐／コーダー
 - 先輩ディレクターのサポート業務（議事録作成、進行管理表更新等）
 - HTML/CSSコーディング業務
 - 簡易的なバナー・LP制作
 - CMS導入・設定作業
 - クライアントサポート業務
・具体的な成果：
 - 20件以上のWebサイト制作プロジェクトに参画
 - レスポンシブ対応のコーディングスキル習得
 - 制作フローの一部を効率化し、納期短縮に貢献
・使用した技術・ツール：
 - HTML/CSS/JavaScript
 - Adobe Photoshop、Illustrator
 - WordPress、Movable Type
・身につけたスキル：
 - Web制作の基礎知識と実務経験
 - チーム内コミュニケーション力
 - デザイナー・エンジニアとの協業ノウハウ

【受賞・表彰歴】
・2023年度 株式会社Algomaticデジタル社内表彰「優秀プロジェクト賞」受賞
 - アパレルECサイトリニューアルプロジェクトでの成果が評価
・2022年度 株式会社Algomaticデジタル「新人賞」受賞
 - 入社1年目ながら複数プロジェクトの安定した進行と顧客満足度向上が評価

【資格】
・Webディレクション検定 2級（2022年5月取得）
・HTML5プロフェッショナル認定試験 レベル1（2021年6月取得）
・Google アナリティクス個人認定資格（GAIQ）（2022年8月取得）
・Adobe XD認定エキスパート（2023年3月取得）

【マネジメント経験】
・小規模案件（2〜3名程度）のチームリーダー経験あり（2022年10月〜現在）
・新入社員1名の指導担当として、基本的なディレクション業務の教育を担当（2023年4月〜9月）
・社内勉強会の企画・運営（2023年7月〜現在、月1回のペースで開催）
 - テーマ：最新のWeb制作トレンド、UI/UX改善手法、SEO対策など

【語学力】
・英語：ビジネスメール対応レベル
 - TOEIC 720点（2022年6月）
 - 海外クライアント向け制作物の英文要件確認・調整経験あり
` as const;
